import { PATHS } from "../constants/paths"
import MenuIcon from "@mui/icons-material/Menu"
import { Drawer, Link, ListItem, Stack } from "@mui/material"
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import IconButton from "@mui/material/IconButton"
import List from "@mui/material/List"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemText from "@mui/material/ListItemText"
import React, { useState } from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../store"
import { disconnectHandler } from "../utils/connectHandler"
import { useDialog } from "../context/DialogContext"
import { DepositDialog } from "./dialog/DepositDialog"
import { WithdrawalDialog } from "./dialog/WithdrawalDialog"
import { socials } from "../data/socials"

const DrawerMenu = () => {
  const [open, setOpen] = useState(false)

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const disconnect = async () => {
    try {
      const result = await disconnectHandler(dispatch, user.sessionToken)
      if (result && result.success) {
        navigate("/")
      }
    } catch (error) {
      console.error("Disconnect error:", error)
      // В любом случае переходим на главную после выхода
      navigate("/")
    }
  }

  const [openDepositDialog, closeDepositDialog] = useDialog()
  const [openWithdrawalDialog, closeWithdrawalDialog] = useDialog()

  const onOpenDepositDialog = (e) => {
    e.preventDefault()
    openDepositDialog({
      children: (
        <DepositDialog
          closeDialog={closeDepositDialog}
          width={"100%"}
          maxWidth={480}
        />
      ),
    })
  }

  const onOpenWithdrawalDialog = (e) => {
    e.preventDefault()
    openWithdrawalDialog({
      children: (
        <WithdrawalDialog
          closeDialog={closeWithdrawalDialog}
          width={"100%"}
          maxWidth={480}
        />
      ),
    })
  }

  const { user, loading } = useAppSelector((state) => state.user)

  return (
    <>
      <IconButton aria-label="menu" onClick={handleDrawerOpen}>
        <MenuIcon fontSize="inherit" />
      </IconButton>
      <Drawer open={open} onClose={handleDrawerClose} anchor="right">
        <Box
          sx={{
            width: 250,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
          role="presentation"
        >
          <List sx={{ paddingBottom: 0, flex: 1 }}>
            {/* Баланс игрока */}
            {user.address && (
              <>
                <ListItem key="999910" disablePadding>
                  <ListItemText sx={{ paddingLeft: 1, color: "#e8c582" }}>
                    Balances
                  </ListItemText>
                </ListItem>
                <ListItem
                  key="999911"
                  disablePadding
                  sx={{ paddingLeft: 2, color: "#fff" }}
                >
                  <ListItemText
                    sx={{ paddingLeft: 1, paddingTop: 0.5, color: "#fff" }}
                  >
                    Balance:{" "}
                    {user.ztd.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{" "}
                    ZTD
                  </ListItemText>
                </ListItem>

                {user.lockedZtd > 0 && (
                  <ListItem
                    key="999922"
                    disablePadding
                    sx={{ paddingLeft: 2, color: "#fff" }}
                    disabled={true}
                  >
                    <ListItemText
                      sx={{ paddingLeft: 1, paddingTop: 0.5, color: "#fff" }}
                    >
                      Locked:{" "}
                      {user.lockedZtd.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      ZTD
                    </ListItemText>
                  </ListItem>
                )}
              </>
            )}

            <ListItem key="99990" disablePadding>
              <ListItemText sx={{ paddingLeft: 1, color: "#e8c582" }}>
                Main menu
              </ListItemText>
            </ListItem>
            {Object.entries(PATHS).map(([key, value]) => (
              <React.Fragment key={value.ID}>
                {value.TYPE === "public" && value.SUB_TYPE === "main" && (
                  <>
                    {key !== "NFT_BOXES" && key !== "WHITE_PAPER" ? (
                      <>
                        <ListItem key={value.ID} disablePadding>
                          <ListItemButton
                            component={NavLink}
                            to={value.PATH}
                            className="nav-link"
                            onClick={() => handleDrawerClose()}
                            disabled={value.DISABLED}
                          >
                            <ListItemText primary={value.LABEL} />
                          </ListItemButton>
                        </ListItem>
                      </>
                    ) : (
                      <>
                        {key === "NFT_BOXES" ? (
                          <>
                            <ListItemButton
                              component={NavLink}
                              to={value.NFT_BOXES_WITH_TURRETS.PATH}
                              onClick={() => handleDrawerClose()}
                            >
                              <ListItemText
                                primary={value.NFT_BOXES_WITH_TURRETS.LABEL}
                              />
                            </ListItemButton>
                            <ListItemButton
                              component={NavLink}
                              to={value.NFT_BOXES_WITH_TURRETS_2.PATH}
                              onClick={() => handleDrawerClose()}
                            >
                              <ListItemText
                                primary={value.NFT_BOXES_WITH_TURRETS_2.LABEL}
                              />
                            </ListItemButton>
                            <ListItemButton
                              component={NavLink}
                              to={value.NFT_BOXES_WITH_COMMANDERS.PATH}
                              onClick={() => handleDrawerClose()}
                            >
                              <ListItemText
                                primary={value.NFT_BOXES_WITH_COMMANDERS.LABEL}
                              />
                            </ListItemButton>
                            <ListItemButton
                              component={NavLink}
                              to={value.NFT_BOXES_WITH_COMMANDERS_2.PATH}
                              onClick={() => handleDrawerClose()}
                            >
                              <ListItemText
                                primary={
                                  value.NFT_BOXES_WITH_COMMANDERS_2.LABEL
                                }
                              />
                            </ListItemButton>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </>
                )}

                {/*value.SUB_TYPE === "additional" && (
                  <>
                    <Divider />
                    <ListItem key={value.ID} disablePadding>
                      <ListItemButton
                        component={NavLink}
                        to={value.PATH}
                        className="nav-link"
                        onClick={() => handleDrawerClose()}
                      >
                        <ListItemText primary={value.LABEL} />
                      </ListItemButton>
                    </ListItem>
                  </>
                )*/}

                {/* Меню для авторизованного пользователя */}
                {user.address && value.SUB_TYPE === "account" && (
                  <>
                    {key === "ACCOUNT" && (
                      <>
                        <ListItem key="99990" disablePadding>
                          <ListItemText
                            sx={{ paddingLeft: 1, color: "#e8c582" }}
                          >
                            My account
                          </ListItemText>
                        </ListItem>
                      </>
                    )}

                    {key === "WITHDRAWAL" && <></>}

                    <ListItem key={value.ID} disablePadding>
                      <ListItemButton
                        component={NavLink}
                        to={value.PATH}
                        onClick={() => handleDrawerClose()}
                      >
                        <ListItemText primary={value.LABEL} />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}
              </React.Fragment>
            ))}

            {/* Меню для авторизованного пользователя */}
            {user.address && (
              <>
                <ListItem key="99996" disablePadding>
                  <ListItemText sx={{ paddingLeft: 1, color: "#e8c582" }}>
                    Operations
                  </ListItemText>
                </ListItem>

                <ListItem key={"99997"} disablePadding>
                  <ListItemButton
                    component={NavLink}
                    onClick={onOpenWithdrawalDialog}
                    disabled={true}
                  >
                    <ListItemText primary={"Withdrawal"} />
                  </ListItemButton>
                </ListItem>

                <ListItem key={"99998"} disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to={"/withdrawal"}
                    onClick={onOpenDepositDialog}
                    disabled={true}
                  >
                    <ListItemText primary={"Deposit"} />
                  </ListItemButton>
                </ListItem>

                <Divider />
                <ListItem key={"99999"} disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to={"/deposit"}
                    onClick={() => disconnect()}
                  >
                    <ListItemText primary={"Log out"} />
                  </ListItemButton>
                </ListItem>
              </>
            )}
          </List>

          <Divider />

          <Stack
            justifyContent="space-between"
            alignItems="center"
            direction="row"
            px={2}
            py={0.5}
            spacing={1}
            sx={{ marginTop: "auto" }}
          >
            {socials.map((social) => (
              <IconButton component={Link} href={social.link} target="_blank">
                {social.icon}
              </IconButton>
            ))}
          </Stack>
        </Box>
      </Drawer>
    </>
  )
}

export default DrawerMenu
